import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION_Mapper extends BaseFormMapper<HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION> {
		return {};
	}
}

const Mappings: HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION = {
	clientName: 'Client',
	client2SecondaryExpiryDate: 'Date of Expiry2 2',
	client2SecondaryPlaceOfIssuance: 'Place of issuance CityProvince Issuer_2 2',
	client2SecondaryReferenceNumber: 'Reference number_2 2',
	client2SecondaryIdentificationType: 'Identification type_2 2',
	client2SecondaryFirstAndLastName: 'Name First name last name_2 2',
	client1SecondaryPlaceOfIssuance: 'Place of issuance CityProvince Issuer2 1',
	client1SecondaryExpiryDate: 'Date of Expiry2 1',
	client1SecondaryReferenceNumber: 'Reference number2 1',
	client1SecondaryIdentificationType: 'Identification type2 1',
	client1SecondaryFirstAndLastName: 'Name First name last name2 1',
	client2ExpiryDate: 'Date of Expiry 2',
	client1ExpiryDate: 'Date of Expiry 1',
	client1PlaceOfIssuance: 'Place of issuance CityProvince Issuer 1',
	client1ReferenceNumber: 'Reference number 1',
	client1IdentificationType: 'Identification type 1',
	client1FirstAndLastName: 'Name First name last name 1',
	client2PlaceOfIssuance: 'Place of issuance CityProvince Issuer_2',
	client2ReferenceNumber: 'Reference number_2',
	client2IdentificationType: 'Identification type_2',
	client2FirstAndLastName: 'Name First name last name_2',
	agentDateYear: 'Year',
	agentDateMonth: 'Day of',
	agentDateDay: 'This',
	agentDatedAt: 'Dated at',
	confirmationName: 'CONFIRMATION AND ACKNOWLEDGEMENT',
	accountNumber: 'ACCOUNT  if available',
};

export interface HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION {
	clientName: string;
	accountNumber: string;
	confirmationName: string;

	client1FirstAndLastName: string;
	client1SecondaryFirstAndLastName: string;
	client1IdentificationType: string;
	client1SecondaryIdentificationType: string;
	client1ReferenceNumber: string;
	client1SecondaryReferenceNumber: string;
	client1PlaceOfIssuance: string;
	client1SecondaryPlaceOfIssuance: string;
	client1ExpiryDate: string;
	client1SecondaryExpiryDate: string;

	client2FirstAndLastName: string;
	client2SecondaryFirstAndLastName: string;
	client2IdentificationType: string;
	client2SecondaryIdentificationType: string;
	client2ReferenceNumber: string;
	client2SecondaryReferenceNumber: string;
	client2PlaceOfIssuance: string;
	client2SecondaryPlaceOfIssuance: string;
	client2ExpiryDate: string;
	client2SecondaryExpiryDate: string;

	agentDatedAt: string;
	agentDateDay: string;
	agentDateMonth: string;
	agentDateYear: string;
}
